import {
  Component,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { UpsiService } from "../upsi.service";
import { filter, interval, Subscription } from "rxjs";
import { MailProgressService } from "./mail-progress.service";
import { NavigationEnd, Router } from "@angular/router";

@Component({
  selector: "app-mail-status-popup",
  templateUrl: "./mail-status-popup.component.html",
  styleUrls: ["./mail-status-popup.component.scss"],
})
export class MailStatusPopupComponent implements OnInit, OnDestroy {
  visible = false;
  mailStatuses: any[] = [];

  progress = 0;
  sent = 0;
  failed = 0;
  pending = 0;
  total = 0;

  refreshSub?: Subscription;
  upsiIds!: number[];
  private hasResumed = false;
  lastPendingCount = 0;
  lastProgressAt = Date.now();
  private manuallyClosed = false;
  private stuckHandled = false;

  constructor(
    private upsiService: UpsiService,
    private router: Router,
    private mailProgressService: MailProgressService
  ) {}

  ngOnInit(): void {
    this.mailProgressService.progress$.subscribe((event) => {
      if (!event) return;

      if (event.type === "START") {
        this.start(event.upsiIds!, event.formValue!);
      }

      if (event.type === "COMPLETE") {
      }
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.manuallyClosed) {
          return;
        }

        if (this.hasResumed) {
          return;
        }

        const user = sessionStorage.getItem("access_user");
        if (!user) {
          this.visible = false;
          return;
        }

        const key = `ACTIVE_UPSI_IDS_${user}`;
        const saved = localStorage.getItem(key);

        if (saved) {
          this.hasResumed = true;
          this.upsiIds = JSON.parse(saved);
          this.visible = true;
          this.loadMailStatuses();
          this.startAutoRefresh();
        }
      });
  }

  @HostListener("window:beforeunload", ["$event"])
  beforeUnload(event: BeforeUnloadEvent) {
    const user = sessionStorage.getItem("access_user");
    if (!user) return;

    const key = `ACTIVE_UPSI_IDS_${user}`;

    if (localStorage.getItem(key)) {
      event.preventDefault();
      event.returnValue = "";
    }
  }

 start(upsiIds: number[], formValue: any) {
  this.manuallyClosed = false;
  this.stuckHandled = false;

  if (!upsiIds || !formValue) return;

  this.stopAutoRefresh();
  this.resetState();

  this.visible = true;
  this.upsiIds = upsiIds;
  this.total = upsiIds.length;
  this.pending = this.total;

  formValue.upsiId = upsiIds;
  this.upsiService.mailUpsiTransfer(formValue).subscribe();

  this.lastProgressAt = Date.now();
  this.startAutoRefresh();
}


  loadMailStatuses() {
    const payload = { upsiId: this.upsiIds };
    console.log('this.upsiIds',this.upsiIds.length)
    this.upsiService.getMailStatus(payload).subscribe((res) => {
      if (res?.success) {
        this.mailStatuses = res.data || [];
        this.updateProgress();
      }
    });
  }

  updateProgress() {
  if (!this.mailStatuses.length) {
    return;
  }

  this.sent = this.mailStatuses.filter(m => m.status === 1).length;
  this.failed = this.mailStatuses.filter(m => m.status === 2).length;
  this.pending = this.total - (this.sent + this.failed);

  this.progress = Math.round(
    ((this.sent + this.failed) / this.total) * 100
  );

  if (this.pending !== this.lastPendingCount) {
    this.lastPendingCount = this.pending;
    this.lastProgressAt = Date.now();
  }

  if (this.pending <= 0) {
    this.completeProcess();
    return;
  }

  const minutesSinceLastProgress =
    (Date.now() - this.lastProgressAt) / 60000;

  if (minutesSinceLastProgress >= 10) {
    this.handleStuckProcess();
  }
}


  completeProcess() {
    this.stopAutoRefresh();
    this.stuckHandled = false;
    const user = sessionStorage.getItem("access_user");
    if (user) {
      localStorage.removeItem(`ACTIVE_UPSI_IDS_${user}`);
    }

    this.hasResumed = false;

    setTimeout(() => {
      this.visible = false;
      this.resetState();
      this.mailProgressService.complete();
    }, 3000);
  }

  handleStuckProcess() {
    if (this.stuckHandled) {
      return;
    }
    this.stuckHandled = true;
    this.stopAutoRefresh();
    const user = sessionStorage.getItem("access_user");
    if (user) {
      localStorage.removeItem(`ACTIVE_UPSI_IDS_${user}`);
    }
    this.hasResumed = false;
    this.visible = true;

    alert(
      "Email sending appears to have been interrupted. Some emails may not have been sent. Please retry pending emails."
    );

    setTimeout(() => {
      this.visible = false;
      this.mailProgressService.stop();
    }, 3000);
  }

  startAutoRefresh() {
    this.refreshSub = interval(5000).subscribe(() => {
      this.loadMailStatuses();
    });
  }

  stopAutoRefresh() {
    this.refreshSub?.unsubscribe();
  }

  close() {
    this.manuallyClosed = true;
    this.stopAutoRefresh();

    const user = sessionStorage.getItem("access_user");
    if (user) {
      localStorage.removeItem(`ACTIVE_UPSI_IDS_${user}`);
    }

    this.visible = false;
    this.hasResumed = false;

    this.resetState();
    this.mailProgressService.stop();
  }

  ngOnDestroy() {
    this.stopAutoRefresh();
  }

  resetState() {
    this.mailStatuses = [];

    this.progress = 0;
    this.sent = 0;
    this.failed = 0;
    this.pending = 0;
    this.total = 0;

    this.lastPendingCount = 0;
    this.lastProgressAt = Date.now();

    this.upsiIds = [];
  }
}
